window.CoreHRPositionHierarchyAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['CoreHRPositionHierarchyServer']);

    self.createPositionHierarchy = function (brandId, hierarchy) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/position_hierarchies`, 'POST', hierarchy)
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPositionHierarchy = function (brandId) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/position_hierarchies`, 'GET')
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPositionHierarchyStatus = function (brandId) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/position_hierarchies/status`, 'GET')
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deletePositionHierarchy = function (brandId, hierarchyId) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/position_hierarchies/${hierarchyId}`, 'DELETE')
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.publishPositionHierarchy = function (brandId, hierarchyId, payload) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/position_hierarchies/${hierarchyId}`, 'PUT', payload)
            .then(function (data) {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.getPositionHierarchyUserLevels = function (brandId, userId) {
        const deferred = $q.defer();

        _protected.request(`brands/${brandId}/users/${userId}/position_hierarchies/levels`, 'GET')
            .then((data) => {
                if (data?.data?.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, (err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});
